import { default as term } from './term/services'
import { default as signature } from  './signature/services'
import { default as term_tag } from  './term_tag/services'

export default {
    ...term,
    ...signature,
    ...term_tag,
}